define(
  'app/factories/yadisa_product_modal',['app/setup', 'app/views/yadisa_product_modal_view'],
  function (takhfifan, YadisaProductModalView) {
    $(function ($) {
      $('.tkh-yadisa-product-modal').each(function () {
        new takhfifan.YadisaProductModalView({
          el: $(this)
        });
      });
    })
  });
